import React from 'react'
import '../styles/sass/_SideBar.css'
import { Col, Image } from 'react-bootstrap'
// import cv from "../store/MILAGROS RODRIGUEZ-CV.pdf";
// import cvactual from '../store/Milagros_Rodriguez_Coronado.pdf';
// import cvespaniol from '../store/Milagros_Rodriguez_CoronadoES.pdf';
// import resumeenglish from '../store/Milagros_Rodriguez_CoronadoEN.pdf';
import cvespaniol from '../store/Milagros_Rodriguez_C_ES.pdf'
import resumeenglish from '../store/Milagros_Rodriguez_C_EN.pdf'
import picProfile from '../img/sidePP.jpg'
import { connect } from 'redux-zero/react'

const Icons = () => {
  return (
    <div className='profile-footer'>
      <div className='footer-social-icons'>
        <a href='https://github.com/Sharmyn28' target='_blank' rel='noopener noreferrer'><i className='fa fa-github'></i></a>
        <a href='https://www.linkedin.com/in/milagros-rodriguez-coronado/' target='_blank' rel='noopener noreferrer'><i className='fa fa-linkedin'></i></a>
        <a href='https://api.whatsapp.com/send?phone=51987248664&' target='_blank' title='(+51) 987248664' rel='noopener noreferrer'><i className='fa fa-whatsapp'></i></a>
        {/* <a href="https://www.facebook.com/mili.rodriguez.716" target="_blank"><i className="fa fa-facebook"></i></a> */}
        <a href='https://www.instagram.com/sharmyn28/?hl=es' target='_blank' rel='noopener noreferrer'><i className='fa fa-instagram'></i></a>
      </div>
    </div>
  )
}

const SideBar = ({isSpanish}) => {
  return (
    <Col lg={3} md={3} xsHidden smHidden id='side__container'>
      <Image src={picProfile} responsive circle className='center-block profilePic' />
      <div>
        <div className='profile-description'>
          <h3>{isSpanish === true ? 'Hola, soy' : "Hi, I'm"}</h3><h1 className='profile-title'>Milagros <br/><span className='lastname'>Rodríguez Coronado</span></h1>
          <h2 className='profile-subtitle'>{ isSpanish === true ? 'Desarrolladora Front End y Br. Ingeniería Industrial' : 'Front End Developer & Industrial Engineer'}</h2>
        </div>
        <div className='profile-description-feature'>
          <div className='profile-description-ft-item'>
            <p><i className='fa fa-envelope-o'> </i><span className='email'> sharmynrodriguez@gmail.com</span> </p><p><i className='fa fa-phone'> </i> +51 987 248 664</p>
          </div>
        </div>
      </div>
        {isSpanish === true ? <a className='download' target='_blank' href={cvespaniol} download='cv-Milagros Rodriguez.pdf' rel='noopener noreferrer'>Descargue CV</a> :
        <a className='download' target='_blank' href={resumeenglish} download='resume-Milagros Rodriguez.pdf' rel='noopener noreferrer'>Download Resume</a>}
      <Icons />
    </Col>
  )
}

// export default SideBar;  className='profilePic'
const mapToProps = ({ isSpanish }) => ({ isSpanish })
export default connect(mapToProps)(SideBar)



// WEBPACK FOOTER //
// ./src/components/SideBar.js